import type { AbstractError } from '@/domain/errors/abstract-error.js';

export function readOccupiedEpicOwner(error: AbstractError): { displayId: string } | null {
    const displayId = error.args?.[0];
    if (!displayId) {
        return null;
    }
    if (!error.message.includes(displayId)) {
        return null;
    }
    return { displayId };
}
